import { render } from "./BasicSettingsPvModuleFoxSharedContainer.vue?vue&type=template&id=687165d7&scoped=true&ts=true"
import script from "./BasicSettingsPvModuleFoxSharedContainer.vue?vue&type=script&lang=ts"
export * from "./BasicSettingsPvModuleFoxSharedContainer.vue?vue&type=script&lang=ts"

import "./BasicSettingsPvModuleFoxSharedContainer.vue?vue&type=style&index=0&id=687165d7&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687165d7"]])

export default __exports__